export default {
  gfb: {
    tourHint: 'Start intro',
    keyboardInfoHint: 'Keyboard handling',
    autoEditHint: 'Auto edit on/off',
    expandHint: 'Expand all groups',
    collapseHint: 'Collapse all groups',
    undoHint: 'Undo',
    clearHint: 'Remove all building blocks',
    sortHint: 'Sort groups/building blocks',
    selectHint: 'Select all building blocks',
    createGroupHint: 'Create group',
    exportHint: 'Export building blocks',
    deleteHint: 'Remove building block',
    ungroupHint: 'Ungroup building block',
    saveHint: 'Save group',
    tplImport: 'Import template',
    groupImport: 'Import group',
    blockImport: 'Import block',
    blockSelect: 'Select building block',
    exists: 'exists',
    draggable: 'Move building block',
    groups: {
      text: 'Text entry',
      predefined: 'Predefined',
      select: 'Selection',
      range: 'Range',
      header: 'Header',
      userdefined: 'User defined'
    },
    fields: {
      text: {
        label: 'Text',
        icon: 'mdi-form-textbox',
        hint: 'Simple singleline text'
      },
      textarea: {
        label: 'Multiline text',
        icon: 'mdi-text',
        hint: 'Textarea with a defined number of rows'
      },
      number: {
        label: 'Number',
        icon: 'mdi-form-textbox',
        hint: 'Number'
      },
      autocomplete: {
        label: 'Autocomplete',
        icon: 'mdi-feature-search-outline'
      },
      button: {
        label: 'Button',
        icon: 'mdi-cursor-default-click'
      },
      checkbox: {
        label: 'Checkbox',
        icon: 'mdi-check-box-outline'
      },
      switch: {
        label: 'Switch',
        icon: 'mdi-toggle-switch'
      },
      radio: {
        label: 'Selection list',
        icon: 'mdi-radiobox-marked',
        hint: 'Selection from a list of possibilities'
      },
      combobox: {
        label: 'Multiselect',
        icon: 'mdi-format-list-checks'
      },
      select: {
        label: 'Selection',
        icon: 'mdi-arrow-down-drop-circle'
      },
      date: {
        label: 'Date',
        icon: 'mdi-calendar'
      },
      time: {
        label: 'Time',
        icon: 'mdi-clock'
      },
      password: {
        label: 'Password',
        icon: 'mdi-form-textbox-password'
      },
      phone: {
        label: 'Phone',
        icon: 'mdi-phone'
      },
      email: {
        label: 'E-Mail',
        icon: 'mdi-email-outline'
      },
      slider: {
        label: 'Slider',
        icon: 'mdi-ray-start-end',
        hint: 'Selection from a value range'
      },
      range: {
        label: 'Range',
        icon: 'mdi-ray-start-end',
        hint: 'Selection from a value range'
      },
      rating: {
        label: '5 Stars',
        icon: 'mdi-star',
        hint: 'Simple 5 stars rating'
      },
      infotext: {
        label: 'Comment',
        icon: 'mdi-comment',
        hint: 'Fest hinterlegter und nicht bearbeitbarer Text'
      },
      sparkline: {
        label: 'Chart',
        icon: 'mdi-chart-line',
        hint: 'Time course of values'
      },
      spacer: {
        label: 'Placeholder',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: 'Empty field'
      },
      gap: {
        label: 'Gap',
        icon: 'mdi-arrow-up-down-bold-outline',
        hint: ''
      },
      divider: {
        label: 'Subheader',
        icon: 'mdi-minus',
        hint: 'Header with divider'
      },
      subheader: {
        label: 'Header',
        icon: 'mdi-page-layout-header',
        hint: 'Subheader for groups'
      },
      note: {
        label: 'School grade',
        icon: 'mdi-music-note',
        hint: 'Award of a school grade 1-6'
      },
      duration: {
        label: 'Duration',
        icon: 'mdi-timer',
        hint: 'hh:mm:ss'
      },
      link: {
        label: 'Link',
        icon: 'mdi-link',
        hint: 'Reference to another page'
      }
    },
    props: {
      name: {
        label: 'Name',
        hint: 'Name'
      },
      label: {
        label: 'Title',
        hint: 'The title of the building block'
      },
      hint: {
        label: 'Help text',
        hint: 'The help text below the block'
      },
      required: {
        label: 'Mandatory field?',
        hint: 'An input is mandatory'
      },
      readonly: {
        hint: 'Read only?'
      },
      items: {
        hint: 'Selection options. Click on selection for editing.'
      },
      multiple: {
        label: 'Multiple selections'
      },
      rows: {
        hint: 'Number of visible rows'
      },
      min: {
        hint: 'Minimum'
      },
      max: {
        hint: 'Maximum'
      },
      row: {
        label: 'Display options as a row',
        hint: 'The selection options can be displayed next to or below each other.'
      },
      step: {
        hint: 'Step size'
      },
      customLabels: {
        hint: 'Enter individual selections separated by commas'
      }
    },
    actions: {
      edit: 'Edit',
      clone: 'Clone',
      export: 'Export',
      delete: 'Remove'
    },
    field: {
      title: 'Block',
      editTitle: 'Edit block',
      export: 'Export',
      exportHint: 'Consider building block in export',
      requiredHint: 'Block is required',
      fieldtoggleHint: 'Building block must be activated'
    },
    block: {
      title: 'Building block',
      deleteMessage: 'Really remove building block?',
      editTitle: 'Edit building block',
      name: 'Name of building block',
      description: 'Description of building block',
      initials: 'Initials of building block',
      internal: 'Internal use only',
      noRating: 'Without rating',
      weighting: 'Weighting',
      weightingHint: 'Percentage weighting for calculation',
      export: 'Export',
      exportHint: 'Consider building block in export',
      defaultName: 'Without group',
      defaultDescription: 'Building blocks without group assignment',
      activate: 'Activate',
      activateHint: 'Building blocks must be activated',
      deactivate: 'Deactivate',
      deactivateHint: 'Really deactivate building blocks again?'
    },
    rating: {
      option: 'Option',
      header: 'Edit option',
      label: 'Description',
      min: 'Minimum score',
      max: 'Maximum score',
      failed: 'Can be marked as "failed"',
      exclude: 'Exclude from rating',
      include: 'Activate rating',
      setmin: 'Set minimum score',
      setmax: 'Set maximum score',
      weighting: 'Edit weighting'
    },
    cloneblock: {
      title: 'Add block',
      inGroup: 'To current group',
      atEnd: 'Insert at the end'
    },
    sort: {
      first: 'Move to start',
      prev: 'Move up',
      next: 'Move down',
      last: 'Move to end',
      expand: 'Expand group',
      collapse: 'Collapse group'
    },
    keyHandling: {
      home: {key: 'Home', title: 'Set focus on first group'},
      end: {key: 'End', title: 'Set focus on last group'},
      cursorUp: {key: 'Cursor up', title: 'Move focus up one group'},
      cursorDown: {key: 'Cursor down', title: 'Move focus down one group'},
      ctrlHome: {key: 'Ctrl+Home', title: 'Move group to the beginning'},
      ctrlEnd: {key: 'Ctrl+End', title: 'Move group to the end'},
      ctrlCursorUp: {key: 'Ctrl+Cursor up', title: 'Move group up'},
      ctrlCursorDown: {key: 'Ctrl+Cursor down', title: 'Move group down'},
      cursorRight: {key: 'Cursor right', title: 'Expand group'},
      cursorLeft: {key: 'Cursor left', title: 'Collapse group'},
      del: {key: 'Del', title: 'Remove group'}
    }
  }
}
